<udex-button
  #UDExTooltipOpener
  [class.remove-paddings]="noPaddings"
  [size]="size"
  [icon]="'sap-icon://hint'"
  (click)="handleClick()"
  (mouseover)="handleMouseOver()"
  (mouseout)="handleMouseOut()"
  design="Tertiary"
  data-cy="tooltip-opener"
  [disabled]="disabled"
  toggled></udex-button>
<udex-tooltip
  #UDExTooltip
  data-cy="provided-by-tooltip"
  [title]="title"
  horizontal-align="Center"
  vertical-align="Center"
  [placement]="placement"
  [accessible-name]="accessibleName !== '' ? accessibleName : title"
  accessible-role="Dialog">
  <ng-content></ng-content>
</udex-tooltip>
